import React from 'react';

import ViewCmsElementRecords from "Components/Utilities/ViewCmsElementRecords";
import StaffFormsChecklist from "Components/HumanResources/StaffFormsChecklist";
import Authenticated from "Components/Layouts/TTS";
import {faClipboardCheck} from "@fortawesome/free-solid-svg-icons/faClipboardCheck";

/**
 * The Forms section of a staff member's folder: their staff forms checklist and every staff form
 * record filed in their folder, whether they filled it in themselves or a manager did.
 */
export default class HrStaffForms extends React.Component {

    /**
     * @method render
     * @return {*}
     */
    render () {
        const user_id = this.props.match?.params?.user ?? null;

        return (
            <Authenticated title="Staff Forms" titleIcon={faClipboardCheck}>
                <div className="space-y-8">
                    <StaffFormsChecklist userId={user_id} key={user_id} />

                    <section>
                        <h2 className="font-league-spartan font-bold text-2xl mb-4 mx-4">All staff form records</h2>

                        <ViewCmsElementRecords
                            staff_form={true}
                            user_id={user_id}
                            push_to_history={false}
                        />
                    </section>
                </div>
            </Authenticated>
        );
    }
}
